export enum ProductLevel{
    Brand = 'Brand',
    Department = 'Department',
    SubDepartment = 'SubDepartment',
    Category = 'Category',
    SubCategory = 'SubCategory',
}
